// FORM
import CampWrapper from './CampWrapper/form/camp'
import CategoryWrapper from './CategoryWrapper/form/category'
import ClientWrapper from './ClientWrapper/form/client'
import CompanyWrapper from './CompanyWrapper/form/company'
import ContractWrapper from './ContractorWrappper/form/contract'
import EnterpriseWrapper from './EnterpriseWrapper/form/enterprise'
import OptionWrapper from './OptionWrapper/form/options'
import ProfileWrapper from './ProfileWrapper/form/profile'
import SiteWrapper from './SiteWrapper/form/site'
import UserWrapper from './UserWrapper/form/user'
import PersonWrapper from './PersonWrapper/form/person'
import EmailTemplateWrapper from './EmailTemplateWrapper/form/emailtemplate'
import ClaimWrapper from './ClaimWrapper/form/claim'
import ClaimUserWrapper from './ClaimUserWrapper/form/claimUser'
import ParamsWrapper from './ParamsWrapper/form/params'
import ParameterWrapper from './ParametersWrapper/form/FormParameters'
import RangeParameterWrapper from './RangeParametersWrapper/form/FormRangeParameters'
import {ConfigDocumentForm} from './ConfigDocumentWrapper/form/config-document'
import {ConfigFacturationForm} from './ConfigFacturationWrapper/form/config-facturation'
// TABLAS
import {TableCampWrapper} from './CampWrapper/table/TableCamp'
import {TableCategoryWrapper} from './CategoryWrapper/table/category'
import {TableExportDataWrapper} from './ExportDataWrapper/table/TableExportData'
import {TableClientWrapper} from './ClientWrapper/table/TableClient'
import {TableCompanyWrapper} from './CompanyWrapper/table/TableCompany'
import {TableContractWrapper} from './ContractorWrappper/table/TableContract'
import {TableEnterpriseWrapper} from './EnterpriseWrapper/table/Enterprise'
import {TableSiteWrapper} from './SiteWrapper/table/TableSite'
import {TableUserWrapper} from './UserWrapper/table/user'
import {TableProfileWrapper} from './ProfileWrapper/table/profile'
import {TableOptionWrapper} from './OptionWrapper/table/option'
import {TablePersonWrapper} from './PersonWrapper/table/person'
import {TableEmailTemplateWrapper} from './EmailTemplateWrapper/table/TableEmailTemplate'
import {TableParamWrapper} from './ParamsWrapper/table/params'
import {TableRangeParamWrapper} from './RangeParametersWrapper/table/rangeparams'
import {TableConfigDocumentWrapper} from './ConfigDocumentWrapper/table/table-config-document'
import {TableConfigFacturationWrapper} from './ConfigFacturationWrapper/table/table-config-facturation'
// TABS
import UserTab from '../componentes/Tabs/user'
import OptionTab from '../componentes/Tabs/option'
import ProfileTab from '../componentes/Tabs/profile'
import DocumentTab from '../Views/PersonWrapper/Tabs/documents'
import {TableClaimWrapper} from './ClaimWrapper/table/TableClaim'
import {TableClaimUserWrapper} from './ClaimUserWrapper/table/TableClaim'
import ClaimTab from '../componentes/Tabs/claim'
import ClaimUserTab from '../componentes/Tabs/claimUser'
import {TableParametersWrapper} from './ParametersWrapper/table/TableParameters'
import ParameterTab from '../componentes/Tabs/parameters'
import CECOTab from './ContractorWrappper/Tabs/ceco'
export const ListComponentsCentral = {
  'form-camp': <CampWrapper />,
  'form-category': <CategoryWrapper />,
  'form-client': <ClientWrapper />,
  'form-company': <CompanyWrapper />,
  'form-contract': <ContractWrapper />,
  'form-enterprise': <EnterpriseWrapper />,
  'form-option': <OptionWrapper />,
  'form-profile': <ProfileWrapper />,
  'form-site': <SiteWrapper />,
  'form-user': <UserWrapper />,
  'form-params': <ParamsWrapper />,
  'form-config-document': <ConfigDocumentForm />,
  'form-config-facturation': <ConfigFacturationForm />,
  'table-export': <TableExportDataWrapper />,
  'form-person': <PersonWrapper />,
  'form-emailtemplate': <EmailTemplateWrapper />,
  'form-claim': <ClaimWrapper />,
  'form-claim-user': <ClaimUserWrapper />,
  'form-parameters': <ParameterWrapper />,
  'form-range-params': <RangeParameterWrapper />,
  'table-camp': <TableCampWrapper />,
  'table-category': <TableCategoryWrapper />,
  'table-client': <TableClientWrapper />,
  'table-company': <TableCompanyWrapper />,
  'table-contract': <TableContractWrapper />,
  'table-enterprise': <TableEnterpriseWrapper />,
  'table-option': <TableOptionWrapper />,
  'table-profile': <TableProfileWrapper />,
  'table-site': <TableSiteWrapper />,
  'table-user': <TableUserWrapper />,
  'table-person': <TablePersonWrapper />,
  'table-emailtemplate': <TableEmailTemplateWrapper />,
  'table-claim': <TableClaimWrapper />,
  'table-claim-user': <TableClaimUserWrapper />,
  'table-params': <TableParamWrapper />,
  'table-parameters': <TableParametersWrapper />,
  'table-range-params': <TableRangeParamWrapper />,
  'table-config-document': <TableConfigDocumentWrapper />,
  'table-config-facturation': <TableConfigFacturationWrapper />,
  'tab-user': <UserTab />,
  'tab-option': <OptionTab />,
  'tab-profile': <ProfileTab />,
  'tab-document': <DocumentTab />,
  'tab-claim': <ClaimTab />,
  'tab-claim-user': <ClaimUserTab />,
  'tab-parameters': <ParameterTab />,
  'tab-ceco': <CECOTab />,
} as any

export const renderPanelContent = (key: string | undefined) => {
  let component = <></>
  if (key) {
    component = ListComponentsCentral[key]
  }
  return component
}
